import React from 'react';
import { WireProduct } from 'scenes/common/api/quote/types';
import { Heading, Text } from 'components/chroma';
import Section from 'scenes/payments/components/Section';

interface Props {
  product: WireProduct;
  policyNumber: string;
  insuranceType: string;
  details: string;
  period: string;
}

const getDetailName = (product: WireProduct) => {
  switch (product) {
    case WireProduct.Motor:
      return 'Car';
    case WireProduct.Home:
      return 'Home';
    case WireProduct.Landlord:
      return 'Landlord';
    default:
      return 'Car';
  }
};

export default function PolicySummarySection(props: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { product, policyNumber, insuranceType, details, period } = props;

  return (
    <Section id="policysummary" column padding="2rem">
      <Heading size={2}>Policy Summary</Heading>
      <Text>
        <strong>Policy number: </strong> {policyNumber}
      </Text>
      <Text>
        <strong>Insurance type: </strong>
        {insuranceType}
      </Text>
      <Text>
        <strong>{getDetailName(product)} details: </strong>
        {details}
      </Text>
      <Text>
        <strong>Policy period: </strong>
        {period}
      </Text>
    </Section>
  );
}
